import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

export const employeesCountColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
): TableColumn<T> => ({
  id: 'employees',
  acessorKey: 'usersCount',
  label: <Trans i18nKey="employees" />,
  sortable: true,
  ...options,
});
